"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const auth0_react_1 = require("@auth0/auth0-react");
const js_1 = __importDefault(require("@honeybadger-io/js"));
const browser_1 = __importDefault(require("@hyperdx/browser"));
const lp_components_1 = require("lp-components");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const apiActions = __importStar(require("api-actions"));
const components_1 = require("components");
const config_1 = require("config");
const local_storage_1 = require("local-storage");
const merchant_management_v1_api_1 = require("merchant-management-v1-api");
const merchant_portal_components_1 = require("merchant-portal-components");
const utils_1 = require("utils");
const actions = __importStar(require("../actions"));
const forms_1 = require("../forms");
const reducer_1 = require("../reducer");
const HeaderNav_1 = __importDefault(require("./HeaderNav"));
function Header({ allLocations, currentLocation, currentLocationIndex, setCurrentLocationIndex, currentPermissions, fetchLocationDetails, }) {
    // Hooks
    const { user, logout, isAuthenticated } = (0, auth0_react_1.useAuth0)();
    const location = (0, react_router_dom_1.useLocation)();
    // State
    const [displayLocationSelector, setDisplayLocationSelector] = (0, react_1.useState)(false);
    const [isPlaying] = (0, react_1.useState)(config_1.NOTIFICATIONS_INTERVAL_ACTIVE);
    // Vars
    const DELAY = 60 * 1000; // 1 second
    const locationName = currentLocation?.name;
    const locationState = currentLocation?.address?.state;
    const locationStoreNumber = currentLocation?.adsStoreNumber;
    const pushApplicationEnabled = currentLocation?.pushApplicationEnabled;
    const dashboardApplicationEnabled = currentLocation?.dashboardApplicationEnabled;
    const showAdminDropdown = (0, utils_1.operationPermitted)(currentPermissions, config_1.PERMISSION.MANAGE_USERS) ||
        (0, utils_1.operationPermitted)(currentPermissions, config_1.PERMISSION.MANAGE_PROGRAMS);
    const displayedLocationName = `at ${locationName} (${locationStoreNumber})`;
    const { data: notifications = [] } = (0, merchant_management_v1_api_1.useGetMerchantManagementV1LocationsIdNotificationsQuery)({ id: currentLocation?.locationId }, {
        skip: !currentLocation?.locationId,
        pollingInterval: isPlaying ? DELAY : 0,
        refetchOnReconnect: true,
        skipPollingIfUnfocused: true,
    });
    async function setHoneybadgerContext() {
        const [ipResult, accessTokenResult] = await Promise.allSettled([
            fetch('https://api.ipify.org?format=json', {
                signal: AbortSignal.timeout(5000),
            }).then((response) => response.json()),
            utils_1.manageAuth0AccessToken.getAccessTokenSilently()(),
        ]);
        const ipAddress = ipResult.status === 'fulfilled' ? ipResult.value.ip : 'IP not available';
        const accessToken = accessTokenResult.status === 'fulfilled'
            ? accessTokenResult.value
            : 'Token not available';
        js_1.default.setContext({
            userEmail: user?.email,
            storeNumber: locationStoreNumber,
            hyperDxSessionId: (0, utils_1.getCookie)('__rum_sid'),
            bearerToken: accessToken,
            ipAddress: ipAddress,
        });
    }
    (0, react_1.useEffect)(() => {
        if (user) {
            browser_1.default.setGlobalAttributes({
                locationName: locationName,
                locationStoreNumber: String(locationStoreNumber),
                locationState: locationState,
                userEmail: String(user.email),
                userName: String(user.name),
                emailVerified: String(user.email_verified),
            });
            setHoneybadgerContext();
        }
    }, [user]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isAuthenticated && ((0, jsx_runtime_1.jsx)("div", { className: "header-login", children: (0, jsx_runtime_1.jsxs)("div", { className: "header-login__content", children: [(0, jsx_runtime_1.jsxs)("div", { children: [user && user.email, " ", displayedLocationName] }), (0, jsx_runtime_1.jsxs)("ul", { className: "nav", children: [(0, jsx_runtime_1.jsx)("li", { className: "navlink", children: (0, jsx_runtime_1.jsx)(components_1.ButtonLink, { onClick: () => setDisplayLocationSelector(!displayLocationSelector), className: "button-link", disabled: location.pathname.includes('/merchant/account/refund/'), children: "Change Locations" }) }), (0, jsx_runtime_1.jsx)("li", { className: "navlink", children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: (0, config_1.makePath)(config_1.PATH.MERCHANT_PORTAL, config_1.PATH.CONTACT_US), children: "Contact Us" }) }), showAdminDropdown && ((0, jsx_runtime_1.jsxs)("li", { className: "navDropdown", children: [(0, jsx_runtime_1.jsxs)("button", { className: "dropbtn button-link", children: ["Admin", (0, jsx_runtime_1.jsx)("i", { className: "fa fa-caret-down" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "dropdown-content", children: [(0, jsx_runtime_1.jsx)(merchant_portal_components_1.AuthorizedLink, { to: config_1.USER_PORTAL_URL, requiredPermission: config_1.PERMISSION.MANAGE_USERS, children: "User Management" }), (0, jsx_runtime_1.jsx)(merchant_portal_components_1.AuthorizedLink, { to: config_1.PROGRAM_MANAGEMENT_URL, requiredPermission: config_1.PERMISSION.MANAGE_PROGRAMS, children: "Program Management" }), currentLocation?.metadata && ((0, jsx_runtime_1.jsx)(merchant_portal_components_1.AuthorizedLink, { to: config_1.LOCATION_MANAGEMENT_URL, requiredPermission: config_1.PERMISSION.MANAGE_PROGRAMS, forceDisabled: currentLocation.needsToSignNewDealTerms, children: "Location Management" })), (0, jsx_runtime_1.jsx)(merchant_portal_components_1.AuthorizedLink, { to: (0, config_1.makePath)(config_1.PATH.MERCHANT_PORTAL, config_1.PATH.MARKETING), requiredPermission: config_1.PERMISSION.MANAGE_USERS, children: "Marketing Materials" })] })] })), (0, jsx_runtime_1.jsx)("li", { className: "navlink", children: (0, jsx_runtime_1.jsx)(components_1.ButtonLink, { onClick: () => {
                                            sessionStorage.setItem('displayNewDeal', 'true');
                                            return logout({
                                                returnTo: (0, config_1.makeApplicationURL)(config_1.PATH.MERCHANT_PORTAL),
                                            });
                                        }, className: "button-link", children: "Sign out" }) })] })] }) })), (0, jsx_runtime_1.jsx)(HeaderNav_1.default, { pushApplicationEnabled: pushApplicationEnabled, dashboardApplicationEnabled: dashboardApplicationEnabled }), (0, jsx_runtime_1.jsx)(merchant_portal_components_1.NotificationsBanner, { notifications: notifications }), displayLocationSelector && ((0, jsx_runtime_1.jsx)(lp_components_1.Modal, { onClose: () => setDisplayLocationSelector(false), children: (0, jsx_runtime_1.jsx)(forms_1.LocationSelectorForm, { allLocations: allLocations, initialValues: { selectedLocationIndex: currentLocationIndex }, defaultValue: {
                        label: currentLocation.name,
                        value: currentLocationIndex,
                    }, onSubmit: ({ selectedLocationIndex, }) => {
                        setDisplayLocationSelector(false);
                        if (selectedLocationIndex && selectedLocationIndex.value > -1) {
                            fetchLocationDetails(allLocations[selectedLocationIndex.value].locationId).then((res) => (0, local_storage_1.setLocation)(res));
                            return setCurrentLocationIndex(selectedLocationIndex.value);
                        }
                    } }) }))] }));
}
function mapStateToProps(state) {
    return {
        allLocations: reducer_1.selectors.allLocations(state),
        currentLocation: reducer_1.selectors.currentLocation(state),
        currentLocationIndex: reducer_1.selectors.currentLocationIndex(state),
        currentPermissions: reducer_1.selectors.currentPermissions(state),
    };
}
const mapDispatchToProps = {
    setCurrentLocationIndex: actions.setCurrentLocationIndex,
};
const mapApiAuthToProps = {
    fetchLocationDetails: apiActions.fetchLocationDetails,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, utils_1.withApiAuth)(mapApiAuthToProps))(Header);
